import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/commissions',
        name: 'commissions',
        meta: { sideMenuLabel: "Commissioni" },
        component: () => import("./views/commissions.vue")
    },
    {
        path: '/commissionsDirect',
        name: 'commissionsDirect',
        meta: { sideMenuLabel: "Commissioni Direct" },
        component: () => import("./views/commissionsDirect.vue")
    },
];

export default routes;